module.exports = __webpack_public_path__ + "media/src/images/logo_iversity_springer-7100ea54d7dce5d0e0c5609cb76b8a10.svg";